import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Sidebar.css';

function Sidebar() {
    const location = useLocation();
    const isReportsActive = location.pathname.startsWith('/reports');
    const [reportsOpen, setReportsOpen] = useState(isReportsActive);

    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <h2>NEDP Portal</h2>
            </div>
            <nav className="sidebar-nav">
                <NavLink to="/" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'} end>
                    <i className="pi pi-home"></i>
                    <span>Dashboard</span>
                </NavLink>
                <NavLink to="/daily" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
                    <i className="pi pi-calendar"></i>
                    <span>Daily Attendance</span>
                </NavLink>
                <NavLink to="/monthly" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
                    <i className="pi pi-calendar-plus"></i>
                    <span>Monthly Attendance</span>
                </NavLink>
                <NavLink to="/profile" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
                    <i className="pi pi-user"></i>
                    <span>Teacher Profile</span>
                </NavLink>
                <div className={`nav-item nav-parent ${isReportsActive ? 'active' : ''}`} onClick={() => setReportsOpen(!reportsOpen)}>
                    <i className="pi pi-chart-bar"></i>
                    <span>Reports</span>
                    <i className={`pi ${reportsOpen ? 'pi-chevron-down' : 'pi-chevron-right'} submenu-arrow`}></i>
                </div>
                {reportsOpen && (
                    <div className="submenu">
                        <NavLink to="/reports/monthly" className={({ isActive }) => isActive ? 'nav-item sub-item active' : 'nav-item sub-item'}>
                            <i className="pi pi-calendar-plus"></i>
                            <span>Monthly Attendance</span>
                        </NavLink>
                        <NavLink to="/reports/daily" className={({ isActive }) => isActive ? 'nav-item sub-item active' : 'nav-item sub-item'}>
                            <i className="pi pi-calendar"></i>
                            <span>Daily Attendance</span>
                        </NavLink>
                    </div>
                )}
                <NavLink to="/help" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
                    <i className="pi pi-question-circle"></i>
                    <span>Help</span>
                </NavLink>
                <NavLink to="/admin" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
                    <i className="pi pi-shield"></i>
                    <span>Admin Panel</span>
                </NavLink>
            </nav>
            <div className="sidebar-footer">
                <small>Powered by JIAT</small>
            </div>
        </div>
    );
}

export default Sidebar;
